import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { createTheme, ThemeProvider }, "@mui/material/SvgIcon": SvgIcon, "@mui/material/Stack": Stack, "@mui/material/Typography": Typography, "@mui/material/FormControl": FormControl, "@mui/material/FormLabel": FormLabel, "@mui/material/FormGroup": FormGroup, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/Checkbox": Checkbox, "@mui/material/RadioGroup": RadioGroup, "@mui/material/Radio": Radio } } });
export default ClientProvider;
